// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nwuDZ73LJyFxe0CVHmWQ {
    flex: 1;
    text-align: center;
}

.A6z4ncUZ0HRz6ZfkiVUA {
    text-align: center;
    font-size: 24px;
    line-height: 1.5;
}
`, "",{"version":3,"sources":["webpack://./src/pages/waitlist-update/dashboard/components/content-empty.module.css"],"names":[],"mappings":"AAAA;IACI,OAAO;IACP,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,gBAAgB;AACpB","sourcesContent":[".content {\n    flex: 1;\n    text-align: center;\n}\n\n.heading {\n    text-align: center;\n    font-size: 24px;\n    line-height: 1.5;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `nwuDZ73LJyFxe0CVHmWQ`,
	"heading": `A6z4ncUZ0HRz6ZfkiVUA`
};
export default ___CSS_LOADER_EXPORT___;
